"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TikTokCreativeStateHistory = void 0;
var TikTokCreativeStateHistory;
(function (TikTokCreativeStateHistory) {
    let state;
    (function (state) {
        state["AWAITING_FIRST_UPLAOD"] = "awaiting_first_uplaod";
        state["STREAM_ELEMENTS_REJECTED"] = "stream_elements_rejected";
        state["STREAM_ELEMENTS_REVIEW"] = "stream_elements_review";
        state["STREAM_ELEMENTS_REQUESTED"] = "stream_elements_requested";
        state["ADVERTISER_FLAG"] = "advertiser_flag";
        state["ADVERTISER_REVIEW"] = "advertiser_review";
        state["ADVERTISER_REQUESTED"] = "advertiser_requested";
        state["CREATOR_REJECTED"] = "creator_rejected";
        state["APPROVED"] = "approved";
        state["UPLOADING"] = "uploading";
        state["UPLOADED"] = "uploaded";
    })(state = TikTokCreativeStateHistory.state || (TikTokCreativeStateHistory.state = {}));
})(TikTokCreativeStateHistory = exports.TikTokCreativeStateHistory || (exports.TikTokCreativeStateHistory = {}));
